import { encodeValue } from 'utils/base64';

export function svgMarker(color) {
  return encodeValue(
    `
    <svg width="40" height="40" viewBox="0 0 40 40" fill="${color}" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99268 15C4.99268 6.75 11.7427 0 19.9927 0C28.2427 0 34.9927 6.75 34.9927 15C34.9927 18.25 33.7427 21.5 31.9927 24L19.9927 40L7.99268 24C6.24268 21.5 4.99268 18.25 4.99268 15ZM19.9927 7.5C15.7427 7.5 12.4927 10.75 12.4927 15C12.4927 19.25 15.7427 22.5 19.9927 22.5C24.2427 22.5 27.4927 19.25 27.4927 15C27.4927 10.75 24.2427 7.5 19.9927 7.5Z" />
    </svg>
    `.trim(),
  );
}
